import React from 'react'
import { delay, plural } from 'utils'
import { Button, H2, Div, P, Modal } from '@driftt/tide-core'
import './style.css'


import { deleteAccounts, deleteAllAccounts } from 'api/accounts'

const DeleteAccountsModal = ({
  showTransientNotification,
  accountIds,
  fetchAccounts,
  setAccountsLoaded,
  open,
  toggle,
  setLoading,
  isDeletingAll,
  totalAccounts,
  clearSelected,
}) => {
  const handleDelete = async () => {
    setLoading()

    try {
      await deleteAccounts(accountIds)
      await delay(fetchAccounts, 1000) //a bit hacky, but for now need to wait - will ask for updated accounts on response.
    } catch (err) {
      showTransientNotification({ type: 'error', message: 'We had a problem deleting your account.' })
      setAccountsLoaded()
    }
  }

  const handleDeleteAll = async () => {
    clearSelected()

    setLoading()
    try {
      await deleteAllAccounts()
      showTransientNotification({ type: 'success', message: 'A request has been started to delete your accounts. Please refresh this page in a few moments.' })
    } catch (err) {
      showTransientNotification({ type: 'error', message: 'We had a problem deleting your account.' })
      setAccountsLoaded()
    }
  }

  return (
    <Modal
      open={open}
      hidden={!open}
      onClose={toggle()}
      title="Are you sure?"
      type="warning"
      size="small"
    >
      <Div className="drift-confirm-modal-text">
        <H2>Delete {isDeletingAll ? `All ${totalAccounts}` : accountIds.length} {plural('Account')}</H2>
        {isDeletingAll && <P>You have chosen to delete ALL of your accounts in Drift. You can always resync from Salesforce or upload a CSV after the accounts are deleted.</P>}
        {totalAccounts > 100 && <P>Deleting more than 100 accounts may take a few minutes. You can keep working while this is happening, come back and refresh this page.</P>}
        <P>Are you sure you want to delete {plural('this')} {plural('account')}?</P>
      </Div>
      <footer>
        <Button onClick={isDeletingAll ? handleDeleteAll : handleDelete} type="secondary">Yes, I want to delete {plural('this')} {plural('account')}.</Button>
        <Button type="tertiary" onClick={toggle()}>Cancel</Button>
      </footer>
    </Modal>
  )
}

export default props => props.open ? <DeleteAccountsModal {...props} /> : null
